module.exports = __webpack_public_path__ + "static/media/9-8.06c2bda3.mp3";